import { useApi } from '@/composables/api'
import type {
  CompanyAccounting,
  CompanyAccountingRequest,
} from '@deepcloud/api-deep-admin'

const COMPANY_ACCOUNTING_DEFAULT = {
  has_a_blocking_amount_of_open_invoices: false,
  has_open_invoices: false,
  has_overused_box_users: false,
  has_overused_subscriptions: false,
  has_payment_method: false,
  has_resolvable_invoices: false,
}

export const useDeepAdminUsersCompanyAccountingStore = defineStore(
  'deepAdminUsersCompanyAccounting',
  () => {
    const fetchCompanyAccountingPending = ref(false)
    const companyAccounting = ref<CompanyAccounting>({
      ...COMPANY_ACCOUNTING_DEFAULT,
    } as CompanyAccounting)

    const { deepAdminAPI } = useApi()

    async function fetchCompanyAccounting(
      organizationId: string,
      params?: CompanyAccountingRequest,
    ) {
      fetchCompanyAccountingPending.value = true
      try {
        const res = await deepAdminAPI.value.usersCompanyAccounting.get(
          organizationId,
          params,
        )
        const resData = res?.data

        // https://jira.abacus.ch/browse/DEEPBOX-9069
        // Call the API again with `?refresh=true` to have a precise result if match condition
        if (resData?.has_a_blocking_amount_of_open_invoices) {
          if (!params?.refresh) {
            return fetchCompanyAccounting(organizationId, { refresh: true })
          }
        }
        companyAccounting.value = { ...resData }
        return Promise.resolve(res)
      } catch (error) {
        companyAccounting.value = {
          ...COMPANY_ACCOUNTING_DEFAULT,
        }
        return Promise.reject(error)
      } finally {
        fetchCompanyAccountingPending.value = false
      }
    }

    return {
      // state
      fetchCompanyAccountingPending,
      companyAccounting,
      // actions
      fetchCompanyAccounting,
    }
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useDeepAdminUsersCompanyAccountingStore, import.meta.hot),
  )
}
